import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-purchase-addon',
  templateUrl: './why-purchase-addon.component.html',
  styleUrls: ['./why-purchase-addon.component.css']
})
export class WhyPurchaseAddonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
